import {useCallback, useMemo} from 'react';
import {useLocation, useNavigate} from 'react-router';
import openCollectionMaterialFn, {
    readCollectionMaterialViewerState,
    stripCollectionMaterialViewerParams,
} from './openCollectionMaterial';

/**
 * Hook flavor of contract C2 for components rendered inside the router.
 * Prefer this over the bare utility so navigation goes through react-router.
 */
export default function useCollectionMaterialViewer() {
    const navigate = useNavigate();
    const location = useLocation();

    const openCollectionMaterial = useCallback(({materialId, materialKind = 'cm', returnTo} = {}) => {
        openCollectionMaterialFn({materialId, materialKind, returnTo, navigate, location});
    }, [navigate, location]);

    const closeCollectionMaterial = useCallback(() => {
        navigate({
            pathname: location.pathname,
            search: stripCollectionMaterialViewerParams(location.search),
            hash: location.hash,
        }, {replace: true});
    }, [navigate, location]);

    const viewerState = useMemo(
        () => readCollectionMaterialViewerState(location.search),
        [location.search],
    );

    return {openCollectionMaterial, closeCollectionMaterial, viewerState};
}
